import ActiveFundsWidget from "./ActiveFundsWidget";
import DateRangePicker from "./DateRangePicker";

const FiltersHeader = ({
    isLoading,
    hideActiveFundsWidget,
    onStartDateChange,
    onEndDateChange,
    onFormChange,
    hide,
    modifierClass = null,
}) => {
    const handleFormChange = (e) => {
        if (onFormChange) onFormChange(e)
    }

    return (
        <form
            className={`formStandard ${modifierClass}`}
            style={hide ? { display: "none" } : {}}
            onSubmit={(e) => e.preventDefault()}
            onChange={handleFormChange}
        >
            {!hideActiveFundsWidget &&
                <ActiveFundsWidget />
            }

            <div className="formField">
                <label>Date Range</label>
            </div>
            <DateRangePicker
                isLoading={isLoading}
                onStartDateChange={onStartDateChange}
                onEndDateChange={onEndDateChange}
            />
        </form>
    )
}

export default FiltersHeader